<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="MAGACIN.NAZIV.SINGULAR"></span></label> -->
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtNaziv"
                  formControlName="Naziv"
                  #focusElement
                  [MaxLength]="100"
                  [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                  [Label]="'MAGACIN.NAZIV.SINGULAR'">
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                      <span *ngFor="let validation of errorMessages.Naziv">
                        <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                  </div>
              </div>
            </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="MAGACIN.SNAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtSnaziv"
                formControlName="SNaziv"
                [MaxLength]="5"
                [ngClass]="{'is-invalid': submitted && fc.SNaziv.invalid}"
                [Label]="'MAGACIN.SNAZIV.SINGULAR'">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.SNaziv.invalid">
                    <span *ngFor="let validation of errorMessages.SNaziv">
                      <span class="error-message" *ngIf="fc.SNaziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                </div>
            </div>
          </div>
          <!-- <div class="form-group row">
            <div class="col-md-12">
              <yt-input
                [Type]="'number'"
                name="txtSortIndex"
                formControlName="SortIndex"
                [Label]="'SORTINDEX.SINGULAR'"
                >
              </yt-input>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </form>